enum IngestionMode {
    Flexible = 'Flexible',
    Strict = 'Strict'
}

export default IngestionMode;